import { CONTACT } from '@/lib/constants'

export const WHATSAPP_NUMBER = CONTACT.whatsapp.replace(/\D/g, '')

export type ProductType = 'lodge' | 'activity' | 'experience'
export type Locale = 'en' | 'es' | 'pt'

export interface WhatsAppUrlParams {
  productName: string
  productType: ProductType
  locale: Locale
  dates?: { checkIn?: string; checkOut?: string }
  guests?: number
}

const MESSAGE_TEMPLATES: Record<Locale, Record<ProductType, string>> = {
  en: {
    lodge: "Hi! I'm interested in booking at {name}. Could you provide more information about availability and pricing?",
    activity: "Hi! I'm interested in the {name} activity. Could you provide more information about availability and pricing?",
    experience: "Hi! I'm interested in the {name} experience. Could you provide more information and pricing?",
  },
  es: {
    lodge: "¡Hola! Me interesa reservar en {name}. ¿Podrían darme más información sobre disponibilidad y precios?",
    activity: "¡Hola! Me interesa la actividad {name}. ¿Podrían darme más información sobre disponibilidad y precios?",
    experience: "¡Hola! Me interesa la experiencia {name}. ¿Podrían darme más información y precios?",
  },
  pt: {
    lodge: "Olá! Estou interessado em reservar em {name}. Poderiam fornecer mais informações sobre disponibilidade e preços?",
    activity: "Olá! Estou interessado na atividade {name}. Poderiam fornecer mais informações sobre disponibilidade e preços?",
    experience: "Olá! Estou interessado na experiência {name}. Poderiam fornecer mais informações e preços?",
  },
}

export function buildWhatsAppUrl(params: WhatsAppUrlParams): string {
  const { productName, productType, locale, dates, guests } = params

  const template = MESSAGE_TEMPLATES[locale]?.[productType] ?? MESSAGE_TEMPLATES.en[productType]
  let message = template.replace('{name}', productName)

  if (dates?.checkIn && dates?.checkOut) {
    message += ` Check-in: ${dates.checkIn} - Check-out: ${dates.checkOut}.`
  }
  if (guests) {
    message += ` Guests: ${guests}.`
  }
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
}
